// extracted by mini-css-extract-plugin
export default {"Admin":"Admin_Admin__SkyGV","preview":"Admin_preview__5BAGE","group":"Admin_group__6ZH+j"};